import { render, staticRenderFns } from "./pdaMenu.vue?vue&type=template&id=ac5a24a0&scoped=true"
import script from "./pdaMenu.vue?vue&type=script&lang=js"
export * from "./pdaMenu.vue?vue&type=script&lang=js"
import style0 from "./pdaMenu.vue?vue&type=style&index=0&id=ac5a24a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5a24a0",
  null
  
)

export default component.exports